var DEFAULT = 0;
var counter = DEFAULT;
export var useUuid = function () {
    var getUuid = function () {
        var current = counter;
        counter = counter + 1;
        return current;
    };
    var resetUuid = function () {
        counter = DEFAULT;
    };
    return [getUuid, resetUuid];
};
